// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/engagement/preset_email_templates" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementPresetEmailTemplates } from "./constants";
import type { EngagementPresetEmailTemplatesParams, EngagementPresetEmailTemplatesResult } from "./types";

export const getDataTableEngagementPresetEmailTemplates = reactQueryFetcherAdapter(
  engagementPresetEmailTemplates,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: EngagementPresetEmailTemplatesParams
  ): Promise<EngagementPresetEmailTemplatesResult> => {
    return fetch(
      "/engagement/preset_email_templates",
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query),
        show_all_template_types: true,
      },
      { signal }
    );
  }
);
